import { render } from "./ManageTemplateModal.vue?vue&type=template&id=6be4131b&ts=true"
import script from "./ManageTemplateModal.vue?vue&type=script&lang=ts"
export * from "./ManageTemplateModal.vue?vue&type=script&lang=ts"

import "./ManageTemplateModal.vue?vue&type=style&index=0&id=6be4131b&lang=css"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__